import { lazy } from 'react';

export const PdpSharedSellerTabsVariantLazy = lazy(
    () =>
        import(/* webpackChunkName: "PdpSharedContactTabsVariant" */ './PdpSharedSellerTabsVariant')
);
